module.exports = __webpack_public_path__ + "images/303  Grande Suite - The Babel Community Paris Montigny Coliving (3).jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/babel/303  Grande Suite - The Babel Community Paris Montigny Coliving (3).jpg
// module id = 49
// module chunks = 0